"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountManagers = exports.transferFrequency = exports.documentSources = exports.leadSources = exports.australiaStates = exports.streetTypes = exports.registrationStatuses = exports.leadStatuses = exports.beneficiaryStatuses = exports.dialCodes = exports.currencies = exports.countries = exports.documentTypes = exports.transferAmounts = exports.transferPurposes = exports.businessTypes = exports.industries = exports.unqualifiedReasons = exports.businessRoles = exports.affiliates = void 0;
exports.affiliates = [
    'ABA Legal',
    'Accenture - Employee Rates',
    'Australia Student Recruitment',
    'Australian Fintech',
    'Backpackers in Paradise',
    'Best Exchange Rates',
    'Brent Hill',
    'CTurtle',
    'Canstar',
    'Charlie Quinn',
    'Compare The Market',
    'Compare and Choose',
    'Comparison Website',
    'Connor Summers - Loan Market',
    'Credit Savvy',
    'Crown Relocations',
    'Cuex',
    'Currency Shop',
    'Dogtainers',
    'Ebroker',
    'Facebook',
    'FinanceNZ',
    'Find Exchange',
    'Finder Australia',
    'Finder Hong Kong',
    'Finder NZ',
    'Finder Singapore',
    'Finemarks Migration Services',
    'Global Knect',
    'Google',
    'I Compare FX',
    'IGM-Consulting',
    'Jon Capal',
    'Maddocks Accountancy',
    'Mozo',
    'Ocean Home Loans',
    'Omni Wealth',
    'Parker Buyer Associates',
    'Pete Skinner',
    'Pets Abroad UK',
    'PocketWise',
    'Qantas - Employee BR',
    'Quot8',
    'Quot8 - Newsletter',
    'Quot8 - Website',
    'Raine & Horne - Aaron Worrad',
    'Raine & Horne - Ben Brackenridge',
    'Rate City',
    'ReloConnect',
    'Relocator',
    'SLICE',
    'Saver Asia',
    'Send4X',
    'Service.com.au',
    'Sirelo',
    'Sirelo Newsletter',
    'Star Dynamic Investments',
    'Stone',
    'Superyacht Crew International',
    'This is Australia',
    'Top 10 Money Transfer',
    'UniAdvisor',
];
exports.businessRoles = ['Owner', 'Director', 'Other'];
exports.unqualifiedReasons = [
    'Customer stopped responding',
    'Do not contact',
    'Duplicate',
    'Invalid contact details',
    'Not interested',
    'Requirement changed',
    'Test leads',
    'Unable to reach customer',
    'Untradeable',
    'Used bank',
    'Used competitor - OFX',
    'Used competitor - Other',
    'Used competitor - TorFX',
    'Used competitor - WISE',
];
exports.industries = [
    'Charity',
    'Consulting',
    'Design',
    'Education',
    'Entertainment',
    'Financial Services',
    'Food, Beverages, Tabacco',
    'Government',
    'Health, Sports',
    'IT',
    'Import, Export',
    'Legal Services',
    'Manufacturing',
    'Marketing',
    'Online Retail, eCommerce',
    'Other',
    'Real Estate, Construction',
    'Retail',
    'Transport',
    'Travel',
    'Wholesale',
];
exports.businessTypes = ['Company', 'Sole Trader', 'Trust', 'Partnership', 'Pty Ltd', 'SMSF'];
exports.transferPurposes = [
    'Buying a vehicle',
    'Buying or selling a business',
    'Buying or selling shares',
    'Donating to charity',
    'Emigration',
    'Family support',
    'Gift',
    'Inheritance',
    'Intra-company transactions',
    'Living expenses',
    'Medical costs',
    'Online store purchase',
    'Paying bills/mortgage',
    'Paying business invoice',
    'Pay employees',
    'Pay suppliers',
    'Paying for holiday/accommodation',
    'Payroll',
    'Pension/superannuation transfer',
    'Professional services',
    'Property purchase/sale',
    'Salary transfer',
    'Tuition/school fees',
    'Wedding',
    'Other',
];
exports.transferAmounts = [
    'Under $1K',
    '$1K - $5K',
    '$5K - $10K',
    '$10K - $25K',
    '<$25k',
    '$25k to $100k',
    '$25K - $50K',
    '$50K - $100K',
    '$100K - $250K',
    '$100k to $500k',
    '$250K - $500K',
    '$500K - $1M',
    '$500k to $1m',
    '$1M+',
    '>$1m',
];
exports.documentTypes = ['Proof of Identity', 'Proof of Address', 'Bank Statement', 'Invoice'];
exports.countries = [
    'Australia',
    'United Kingdom',
    'New Zealand',
    'United States of America',
    'Canada',
    'India',
    'Germany',
    'France',
    'Abkhazia',
    'Afghanistan',
    'Albania',
    'Algeria',
    'American Samoa (United States of America)',
    'Andorra',
    'Angola',
    'Anguilla (United Kingdom)',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bonaire, Sint Eustatius & Saba',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'British Indian Ocean Territory (United Kingdom)',
    'British Virgin Islands (United Kingdom)',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Cape Verde',
    'Cayman Islands (United Kingdom)',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo',
    'Cook Islands (Pacific Ocean)',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Curaçao',
    'Cyprus',
    'Czech Republic',
    'Democratic Republic of the Congo',
    'Denmark (Kingdom of Denmark)',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'East Timor',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands (United Kingdom)',
    'Faroe Islands (Kingdom of Denmark)',
    'Fiji',
    'Finland',
    'French Guiana (France)',
    'French Indian Ocean Territories (France)',
    'French Polynesia (France)',
    'Gabon',
    'Gambia',
    'Georgia',
    'Ghana',
    'Gibraltar (United Kingdom)',
    'Greece',
    'Greenland (Kingdom of Denmark)',
    'Grenada',
    'Guadeloupe (France)',
    'Guam (United States of America)',
    'Guatemala',
    'Guernsey (United Kingdom)',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man (United Kingdom)',
    'Israel',
    'Italy',
    'Ivory Coast',
    'Jamaica',
    'Japan',
    'Jersey (United Kingdom)',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Korea, North',
    'Korea, South',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macao',
    'North Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique (France)',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia, Federated States of',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat (United Kingdom)',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands (Kingdom of the Netherlands)',
    'New Caledonia',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands (United States of America)',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Romania',
    'Russian Federation',
    'Rwanda',
    'Saint Barthélemy (France)',
    'Saint Helena, Ascension and Tristan da Cunha',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin (France)',
    'Saint Pierre and Miquelon',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Sint Maarten',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Arab Emirates (Abu Dhabi)',
    'United Arab Emirates (Dubai)',
    'United States Virgin Islands',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
    'Wallis and Futuna',
    'Yemen',
    'Zambia',
    'Zimbabwe',
];
exports.currencies = [
    ['Australian dollar', 'AUD'],
    ['New Zealand dollar', 'NZD'],
    ['United States dollar', 'USD'],
    ['British pound', 'GBP'],
    ['Euro', 'EUR'],
    ['Canadian dollar', 'CAD'],
    ['Indian rupee', 'INR'],
    ['Singapore dollar', 'SGD'],
    ['United Arab Emirates dirham', 'AED'],
    ['Afghan afghani', 'AFN'],
    ['Albanian lek', 'ALL'],
    ['Armenian dram', 'AMD'],
    ['Angolan kwanza', 'AOA'],
    ['Argentine peso', 'ARS'],
    ['Azerbaijani manat', 'AZN'],
    ['Bosnia and Herzegovina convertible mark', 'BAM'],
    ['Barbadian dollar', 'BBD'],
    ['Bangladeshi taka', 'BDT'],
    ['Bulgarian lev', 'BGN'],
    ['Bahraini dinar', 'BHD'],
    ['Burundian franc', 'BIF'],
    ['Brunei dollar', 'BND'],
    ['Bolivian boliviano', 'BOB'],
    ['Brazilian real', 'BRL'],
    ['Bahamian dollar', 'BSD'],
    ['Bhutanese ngultrum', 'BTN'],
    ['Botswana pula', 'BWP'],
    ['Belarusian ruble', 'BYN'],
    ['Belize dollar', 'BZD'],
    ['Congolese franc', 'CDF'],
    ['Swiss franc', 'CHF'],
    ['Chilean peso', 'CLP'],
    ['Chinese yuan', 'CNY'],
    ['Colombian peso', 'COP'],
    ['Costa Rican colón', 'CRC'],
    ['Cuban peso', 'CUP'],
    ['Cape Verdean escudo', 'CVE'],
    ['Czech koruna', 'CZK'],
    ['Djiboutian franc', 'DJF'],
    ['Danish krone', 'DKK'],
    ['Dominican peso', 'DOP'],
    ['Algerian dinar', 'DZD'],
    ['Egyptian pound', 'EGP'],
    ['Eritrean nakfa', 'ERN'],
    ['Ethiopian birr', 'ETB'],
    ['Fijian dollar', 'FJD'],
    ['Georgian lari', 'GEL'],
    ['Ghanaian cedi', 'GHS'],
    ['Gambian dalasi', 'GMD'],
    ['Guinean franc', 'GNF'],
    ['Guatemalan quetzal', 'GTQ'],
    ['Guyanese dollar', 'GYD'],
    ['Honduran lempira', 'HNL'],
    ['Hong Kong dollar', 'HKD'],
    ['Croatian kuna', 'HRK'],
    ['Haitian gourde', 'HTG'],
    ['Hungarian forint', 'HUF'],
    ['Indonesian rupiah', 'IDR'],
    ['Israeli new shekel', 'ILS'],
    ['Iraqi dinar', 'IQD'],
    ['Iranian rial', 'IRR'],
    ['Icelandic króna', 'ISK'],
    ['Jamaican dollar', 'JMD'],
    ['Jordanian dinar', 'JOD'],
    ['Japanese yen', 'JPY'],
    ['Kenyan shilling', 'KES'],
    ['Kyrgyzstani som', 'KGS'],
    ['Cambodian riel', 'KHR'],
    ['Comorian franc', 'KMF'],
    ['North Korean won', 'KPW'],
    ['South Korean won', 'KRW'],
    ['Kuwaiti dinar', 'KWD'],
    ['Kazakhstani tenge', 'KZT'],
    ['Lao kip', 'LAK'],
    ['Lebanese pound', 'LBP'],
    ['Sri Lankan rupee', 'LKR'],
    ['Liberian dollar', 'LRD'],
    ['Lesotho loti', 'LSL'],
    ['Libyan dinar', 'LYD'],
    ['Moroccan dirham', 'MAD'],
    ['Moldovan leu', 'MDL'],
    ['Malagasy ariary', 'MGA'],
    ['Macedonian denar', 'MKD'],
    ['Burmese kyat', 'MMK'],
    ['Mongolian tögrög', 'MNT'],
    ['Mauritanian ouguiya', 'MRO'],
    ['Mauritian rupee', 'MUR'],
    ['Maldivian rufiyaa', 'MVR'],
    ['Malawian kwacha', 'MWK'],
    ['Mexican peso', 'MXN'],
    ['Malaysian ringgit', 'MYR'],
    ['Mozambican metical', 'MZN'],
    ['Namibian dollar', 'NAD'],
    ['Nigerian naira', 'NGN'],
    ['Nicaraguan córdoba', 'NIO'],
    ['Norwegian krone', 'NOK'],
    ['Nepalese rupee', 'NPR'],
    ['Omani rial', 'OMR'],
    ['Panamanian balboa', 'PAB'],
    ['Peruvian sol', 'PEN'],
    ['Papua New Guinean kina', 'PGK'],
    ['Philippine peso', 'PHP'],
    ['Pakistani rupee', 'PKR'],
    ['Polish zloty', 'PLN'],
    ['Paraguayan guaraní', 'PYG'],
    ['Qatari riyal', 'QAR'],
    ['Romanian leu', 'RON'],
    ['Serbian dinar', 'RSD'],
    ['Russian ruble', 'RUB'],
    ['Rwandan franc', 'RWF'],
    ['Saudi riyal', 'SAR'],
    ['Solomon Islands dollar', 'SBD'],
    ['Seychellois rupee', 'SCR'],
    ['Sudanese pound', 'SDG'],
    ['Swedish krona', 'SEK'],
    ['Sierra Leonean leone', 'SLL'],
    ['Somali shilling', 'SOS'],
    ['Surinamese dollar', 'SRD'],
    ['South Sudanese pound', 'SSP'],
    ['São Tomé and Príncipe dobra', 'STD'],
    ['Syrian pound', 'SYP'],
    ['Swazi lilangeni', 'SZL'],
    ['Thai baht', 'THB'],
    ['Tajikistani somoni', 'TJS'],
    ['Turkmenistan manat', 'TMT'],
    ['Tunisian dinar', 'TND'],
    ["Tongan pa'anga", 'TOP'],
    ['Turkish lira', 'TRY'],
    ['Trinidad and Tobago dollar', 'TTD'],
    ['New Taiwan dollar', 'TWD'],
    ['Tanzanian shilling', 'TZS'],
    ['Ukrainian hryvnia', 'UAH'],
    ['Ugandan shilling', 'UGX'],
    ['Uruguayan peso', 'UYU'],
    ['Uzbekistani som', 'UZS'],
    ['Venezuelan bolívar', 'VEF'],
    ['Vietnamese dong', 'VND'],
    ['Vanuatu vatu', 'VUV'],
    ['Samoan tala', 'WST'],
    ['Central African CFA franc', 'XAF'],
    ['East Caribbean dollar', 'XCD'],
    ['West African CFA franc', 'XOF'],
    ['Yemeni rial', 'YER'],
    ['South African rand', 'ZAR'],
    ['Zambian kwacha', 'ZMW'],
];
exports.dialCodes = [
    '+1',
    '+7',
    '+20',
    '+27',
    '+30',
    '+31',
    '+32',
    '+33',
    '+34',
    '+36',
    '+39',
    '+40',
    '+41',
    '+43',
    '+44',
    '+45',
    '+46',
    '+47',
    '+48',
    '+49',
    '+51',
    '+52',
    '+53',
    '+54',
    '+55',
    '+56',
    '+57',
    '+58',
    '+60',
    '+61',
    '+62',
    '+63',
    '+64',
    '+65',
    '+66',
    '+81',
    '+82',
    '+84',
    '+86',
    '+90',
    '+91',
    '+92',
    '+93',
    '+94',
    '+95',
    '+98',
    '+211',
    '+212',
    '+213',
    '+216',
    '+218',
    '+220',
    '+221',
    '+222',
    '+223',
    '+224',
    '+225',
    '+226',
    '+227',
    '+228',
    '+229',
    '+230',
    '+231',
    '+232',
    '+233',
    '+234',
    '+235',
    '+236',
    '+237',
    '+238',
    '+239',
    '+240',
    '+241',
    '+242',
    '+243',
    '+244',
    '+245',
    '+246',
    '+248',
    '+249',
    '+250',
    '+251',
    '+252',
    '+253',
    '+254',
    '+255',
    '+256',
    '+257',
    '+258',
    '+260',
    '+261',
    '+262',
    '+263',
    '+264',
    '+265',
    '+266',
    '+267',
    '+268',
    '+269',
    '+291',
    '+297',
    '+298',
    '+299',
    '+350',
    '+351',
    '+352',
    '+353',
    '+354',
    '+355',
    '+356',
    '+357',
    '+358',
    '+359',
    '+370',
    '+371',
    '+372',
    '+373',
    '+374',
    '+375',
    '+376',
    '+377',
    '+378',
    '+380',
    '+382',
    '+385',
    '+386',
    '+387',
    '+389',
    '+420',
    '+421',
    '+423',
    '+500',
    '+501',
    '+502',
    '+503',
    '+504',
    '+505',
    '+506',
    '+507',
    '+508',
    '+509',
    '+590',
    '+591',
    '+592',
    '+593',
    '+594',
    '+595',
    '+596',
    '+597',
    '+598',
    '+599',
    '+670',
    '+672',
    '+673',
    '+674',
    '+675',
    '+676',
    '+677',
    '+678',
    '+679',
    '+680',
    '+681',
    '+682',
    '+683',
    '+685',
    '+686',
    '+687',
    '+688',
    '+689',
    '+690',
    '+691',
    '+692',
    '+850',
    '+852',
    '+853',
    '+855',
    '+856',
    '+870',
    '+880',
    '+886',
    '+960',
    '+961',
    '+962',
    '+963',
    '+964',
    '+965',
    '+966',
    '+967',
    '+968',
    '+970',
    '+971',
    '+972',
    '+973',
    '+974',
    '+975',
    '+976',
    '+977',
    '+992',
    '+993',
    '+994',
    '+995',
    '+996',
    '+998',
    '+1-242',
    '+1-246',
    '+1-264',
    '+1-268',
];
exports.beneficiaryStatuses = ['New', 'Compliance Pending', 'Verified', 'Beneficiary Failed'];
exports.leadStatuses = ['New', 'In Progress', 'Qualified', 'Unqualified'];
exports.registrationStatuses = [
    'Registration Started',
    'Registered',
    'Compliance Pending',
    'Registration Failed',
    'Inactive',
    'Incomplete',
];
exports.streetTypes = [
    ['Alley', 'Ally'],
    ['Arcade', 'Arc'],
    ['Avenue', 'Ave'],
    ['Boulevard', 'Bvd'],
    ['Bypass', 'Bypa'],
    ['Circuit', 'Cct'],
    ['Close', 'Cl'],
    ['Corner', 'Crn'],
    ['Court', 'Ct'],
    ['Crescent', 'Cres'],
    ['Cul-de-sac', 'Cds'],
    ['Drive', 'Dr'],
    ['Esplanade', 'Esp'],
    ['Green', 'Grn'],
    ['Grove', 'Gr'],
    ['Highway', 'Hwy'],
    ['Junction', 'Jnc'],
    ['Lane', 'Lane'],
    ['Link', 'Link'],
    ['Mews', 'Mews'],
    ['Parade', 'Pde'],
    ['Place', 'Pl'],
    ['Ridge', 'Rdge'],
    ['Road', 'Rd'],
    ['Square', 'Sq'],
    ['Street', 'St'],
    ['Terrace', 'Tce'],
];
exports.australiaStates = ['ACT', 'NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NT'];
exports.leadSources = [
    'Client Referral',
    'Comparison Site',
    'Direct Mail',
    'Facebook',
    'Google',
    'Internet',
    'Newspaper',
    'Telemarketing',
    'Television',
    'Other',
];
exports.documentSources = [
    { key: 'OTHER', value: 'Other' },
    { key: 'DRIVERS_LICENCE', value: 'Drivers Licence' },
    { key: 'PASSPORT', value: 'Passport' },
    { key: 'VISA', value: 'Visa' },
    { key: 'IMMIGRATION', value: 'Immigration' },
    { key: 'NATIONAL_ID', value: 'National ID' },
    { key: 'TAX_ID', value: 'Tax ID' },
    { key: 'NATIONAL_HEALTH_ID', value: 'National Health ID' },
    { key: 'CONCESSION', value: 'Concession' },
    { key: 'HEALTH_CONCESSION', value: 'Health Concession' },
    { key: 'PENSION', value: 'Persion' },
    { key: 'MILITARY_ID', value: 'Military ID' },
    { key: 'BIRTH_CERT', value: 'Birth Certificate' },
    { key: 'CITIZENSHIP', value: 'Citizenship' },
    { key: 'MARRIAGE_CERT', value: 'Marriage Certificate' },
    { key: 'DEATH_CERT', value: 'Death Certificate' },
    { key: 'NAME_CHANGE', value: 'Name Change' },
    { key: 'UTILITY_BILL', value: 'Utility Bill' },
    { key: 'BANK_STATEMENT', value: 'Bank Statement' },
    { key: 'INTENT_PROOF', value: 'Intent Proof' },
    { key: 'ATTESTATION', value: 'Attestation' },
    { key: 'SELF_IMAGE', value: 'Self Image' },
    { key: 'MSISDN', value: 'MSISDN' },
    { key: 'DEVICE', value: 'Device' },
    { key: 'INVOICE', value: 'Invoice' },
];
exports.transferFrequency = ['Weekly', 'Monthly', 'Intermittent', 'One-Off', 'Unsure'];
exports.accountManagers = {
    default: {
        name: 'Support',
        title: '',
        email: 'info@sendpayments.com',
        avatar: '/static/images/send_icon.svg',
        icon: '/static/images/support_icon.png',
        bio: 'Available 8:00 AM - 6:00 PM AEST',
        hobby: 'FX Experts on standby',
    },
    'chris.broadfoot@sendfx.com.au': {
        name: 'Chris',
        title: 'FX Expert',
        email: 'chris.broadfoot@sendfx.com.au',
        avatar: '/static/images/account-managers/chris.png',
        icon: '/static/images/chris_icon.png',
        bio: '5 Years in Foreign Exchange',
        hobby: 'Avid Football (soccer) Supporter',
    },
    'dave.caldaralo@sendfx.com.au': {
        name: 'Dave',
        title: 'FX Expert',
        email: 'dave.caldaralo@sendfx.com.au',
        avatar: '/static/images/account-managers/dave.png',
        icon: '/static/images/dave_icon.png',
        bio: '10+ years in financial services',
        hobby: 'Health & Fitness Enthusiast',
    },
    'dylan.wooster@sendfx.com.au': {
        name: 'Dylan',
        title: 'FX Expert',
        email: 'dylan.wooster@sendfx.com.au',
        avatar: '/static/images/account-managers/dylan.png',
        icon: '/static/images/dylan_icon.png',
        bio: '5 years in Insurance & Financial Services',
        hobby: 'Gold Coast rep rugby player & fan',
    },
    'katy.lord@sendfx.com.au': {
        name: 'Katy',
        title: 'FX Expert',
        email: 'katy.lord@sendfx.com.au',
        avatar: '/static/images/account-managers/katy.png',
        icon: '/static/images/katy_icon.png',
        bio: '5 years in Insurance & Financial Services',
        hobby: 'Health & Fitness Enthusiast',
    },
    'anthony.buttiglieri@sendfx.com.au': {
        name: 'Anthony',
        title: 'FX Expert',
        email: 'anthony.buttiglieri@sendfx.com.au',
        avatar: '/static/images/account-managers/anthony.png',
        icon: '/static/images/anthony_icon.png',
        bio: '',
        hobby: '',
    },
};
//# sourceMappingURL=defaults.js.map